import React from 'react';
import { projectStatusMeta } from '../../data/portfolioProjects';

const colorMap = {
  emerald: 'bg-emerald-500/15 text-emerald-700 ring-emerald-500/30',
  amber: 'bg-amber-500/15 text-amber-700 ring-amber-500/30',
  sky: 'bg-sky-500/15 text-sky-700 ring-sky-500/30',
  slate: 'bg-slate-500/15 text-slate-700 ring-slate-500/30',
  rose: 'bg-rose-500/15 text-rose-700 ring-rose-500/30',
};

const dotMap = {
  emerald: 'bg-emerald-500',
  amber: 'bg-amber-500',
  sky: 'bg-sky-500',
  slate: 'bg-slate-500',
  rose: 'bg-rose-500',
};

const StatusBadge = ({ status, size = 'sm' }) => {
  const meta = projectStatusMeta[status];
  if (!meta) return null;
  const px = size === 'lg' ? 'px-3 py-1 text-xs' : 'px-2 py-0.5 text-[10px]';

  return (
    <span
      className={`inline-flex items-center gap-1.5 ${px} rounded-full font-semibold ring-1 backdrop-blur-sm ${colorMap[meta.color]}`}
    >
      <span className="relative flex h-1.5 w-1.5">
        {meta.pulse && (
          <span
            className={`absolute inline-flex h-full w-full animate-ping rounded-full opacity-75 ${dotMap[meta.color]}`}
          />
        )}
        <span className={`relative inline-flex h-1.5 w-1.5 rounded-full ${dotMap[meta.color]}`} />
      </span>
      {meta.label}
    </span>
  );
};

export default StatusBadge;
